/**
 * Returns the integration name
 *
 * @param {String} integrationCode The integration code
 * @return {String}                 The integration name
 */
const getIntegrationName = ( integrationCode ) => {
	return UncannyAutomator.integrations[ integrationCode ].name;
}

export default getIntegrationName;
